export const entryCountMap = {
  0: '次',
  1: '多次',
  2: '使馆批',
};

export const validityPeriodMap = {
  0: '天',
  1: '月',
  2: '年',
  3: '使馆批',
  4: '按行程批',
  5: '出入境批',
  6: '外专局批',
  7: '外事办批',
  8: '移民局批',
};

// 签证类型
export const visaFormMap = {
  0: '贴纸签',
  1: '电子签',
  2: '另纸签',
  3: '电子批文签',
};
